module.exports = __webpack_public_path__ + "../static/img/base_timos.49cf8c97.png";